import AnnulationPopupController from './annulation.popup.controller';

export default {
    bindings: {
        modalInstance: '='
    },
    template: require('./annulation.popup.html'),
    controller: AnnulationPopupController
};
